module.exports = __webpack_public_path__ + "img/icon_11.e04f7197.png";